/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ConnectorUptimeSummary
 */
export interface ConnectorUptimeSummary {
    /**
     * Device identity
     * @type {string}
     * @memberof ConnectorUptimeSummary
     */
    deviceIdentity?: string;
    /**
     * Device friendly name
     * @type {string}
     * @memberof ConnectorUptimeSummary
     */
    deviceFriendlyName?: string;
    /**
     * Connector index (1-based)
     * @type {number}
     * @memberof ConnectorUptimeSummary
     */
    connectorIndex?: number;
    /**
     * Uptime percentage (0-1). Offline periods are not considered.
     * @type {number}
     * @memberof ConnectorUptimeSummary
     */
    uptimeOfflineIncluded?: number;
    /**
     * Uptime percentage (0-1). Offline periods are removed from calculation.
     * @type {number}
     * @memberof ConnectorUptimeSummary
     */
    uptimeOfflineExcluded?: number;
    /**
     * Preferred uptime based on organisation preference.
     * @type {number}
     * @memberof ConnectorUptimeSummary
     */
    preferredUptime?: number;
    /**
     * Whether offline is included in preferred calculation.
     * @type {boolean}
     * @memberof ConnectorUptimeSummary
     */
    isOfflineIncluded?: boolean;
    /**
     * Parent site device group tag
     * @type {string}
     * @memberof ConnectorUptimeSummary
     */
    siteGroupTag?: string;
    /**
     * Parent site name
     * @type {string}
     * @memberof ConnectorUptimeSummary
     */
    siteName?: string;
    /**
     * Parent organisation device group tag
     * @type {string}
     * @memberof ConnectorUptimeSummary
     */
    orgGroupTag?: string;
    /**
     * Parent organisation name
     * @type {string}
     * @memberof ConnectorUptimeSummary
     */
    orgName?: string;
    /**
     * All device group tags this connector belongs to (for OData filtering)
     * @type {Array<string>}
     * @memberof ConnectorUptimeSummary
     */
    deviceGroupTags?: Array<string>;
    /**
     * Calculation period start
     * @type {Date}
     * @memberof ConnectorUptimeSummary
     */
    periodStart?: Date;
    /**
     * Calculation period end
     * @type {Date}
     * @memberof ConnectorUptimeSummary
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the ConnectorUptimeSummary interface.
 */
export function instanceOfConnectorUptimeSummary(
    value: object,
): value is ConnectorUptimeSummary {
    return true;
}

export function ConnectorUptimeSummaryFromJSON(
    json: any,
): ConnectorUptimeSummary {
    return ConnectorUptimeSummaryFromJSONTyped(json, false);
}

export function ConnectorUptimeSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorUptimeSummary {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        deviceFriendlyName:
            json["deviceFriendlyName"] == null
                ? undefined
                : json["deviceFriendlyName"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        uptimeOfflineIncluded:
            json["uptimeOfflineIncluded"] == null
                ? undefined
                : json["uptimeOfflineIncluded"],
        uptimeOfflineExcluded:
            json["uptimeOfflineExcluded"] == null
                ? undefined
                : json["uptimeOfflineExcluded"],
        preferredUptime:
            json["preferredUptime"] == null
                ? undefined
                : json["preferredUptime"],
        isOfflineIncluded:
            json["isOfflineIncluded"] == null
                ? undefined
                : json["isOfflineIncluded"],
        siteGroupTag:
            json["siteGroupTag"] == null ? undefined : json["siteGroupTag"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        orgGroupTag:
            json["orgGroupTag"] == null ? undefined : json["orgGroupTag"],
        orgName: json["orgName"] == null ? undefined : json["orgName"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function ConnectorUptimeSummaryToJSON(
    value?: ConnectorUptimeSummary | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        deviceFriendlyName: value["deviceFriendlyName"],
        connectorIndex: value["connectorIndex"],
        uptimeOfflineIncluded: value["uptimeOfflineIncluded"],
        uptimeOfflineExcluded: value["uptimeOfflineExcluded"],
        preferredUptime: value["preferredUptime"],
        isOfflineIncluded: value["isOfflineIncluded"],
        siteGroupTag: value["siteGroupTag"],
        siteName: value["siteName"],
        orgGroupTag: value["orgGroupTag"],
        orgName: value["orgName"],
        deviceGroupTags: value["deviceGroupTags"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
